
/**
 * 
 */

import React from 'react';
import i18n from  "./../../Documental/Localization/i18n.js";


class ErrorBar extends React.Component {

  constructor( props ) {
    super( props );

    let msg = i18n.t( "An technical error occurred, please try again." );
    if( typeof props.message !== "undefined" ){
      msg = props.message;
    }

    let closable = true;
    if( typeof props.closable !== "undefined" ){
      closable = props.closable;
    }

    this.state = { 
      "displayState" : "opened",
      "errorHeading" : i18n.t( "Problem" ),
      "errorMessage" : msg,
      "closable" : closable
    }
    
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }


  handleCloseClick(event) {
    this.setState ({ 
      "displayState" : "closed"
    });
  }


  render() {

    let classeNames = "top-bar-error " + this.state.displayState;

    if( typeof this.props.className !== "undefined" ){
      classeNames = classeNames + this.props.className;
    }

    return (
      <div className=""  className={classeNames} >
        <div className="inner">
          <div className="col-icon">
            <span className="icon-alert"></span>
          </div>
          <div className="col-content">
            <div className="heading">{this.state.errorHeading}</div>
            <div className="content">
              {this.state.errorMessage}
              {this.props.children}
            </div>
          </div>
          {(this.state.closable ) && ( <span className="close-error" onClick={this.handleCloseClick}></span>)}
        </div>
      </div>
    );
  }

}

export default ErrorBar; 